import { asNodeIDArray } from "@hex-insights/app-modules";
import {
	asArray,
	mapFilter,
	nullableBooleanTypeFilter,
	nullableNumberTypeFilter,
	TypeFilterObject,
	valuesTypeFilter,
} from "@hex-insights/core";
import { AttendanceStatus, Campus, HomeRoomSection } from "../../../Utilities";

export type StandardFilterFormValues = {
	statusEQ: "Enrolled" | "Future" | "Former" | "Not Enrolled" | null;
	campusIDsIn: Campus["id"][];
	graduationYearIn: number[];
	graduationYearEQ: number | null;
	homeRoomSectionIDIn: HomeRoomSection["id"][];
	attendanceStatusTodayIDIn: AttendanceStatus["id"][];
	hasAttendanceToday: boolean | null;
	reEnrollmentStatusEQ: "Re-Enrolling" | "Withdrawing" | "No Response" | null;
	reEnrollmentMealPlan: boolean | null;
	reEnrollmentContractStatusEQ: "Incomplete" | "Ready for Review" | "Approved" | "Signed & Uploaded" | null;
};

export const initialStandardFilters: StandardFilterFormValues = {
	statusEQ: null,
	campusIDsIn: [],
	graduationYearIn: [],
	graduationYearEQ: null,
	homeRoomSectionIDIn: [],
	attendanceStatusTodayIDIn: [],
	hasAttendanceToday: null,
	reEnrollmentStatusEQ: null,
	reEnrollmentMealPlan: null,
	reEnrollmentContractStatusEQ: null,
};

export const standardFiltersTypeFilterObject: TypeFilterObject<StandardFilterFormValues> = {
	statusEQ: valuesTypeFilter(["Enrolled", "Future", "Former", "Not Enrolled", null], null),
	campusIDsIn: asNodeIDArray,
	graduationYearIn: (value) => mapFilter(asArray(value), nullableNumberTypeFilter(null), (e) => e !== null) as number[],
	graduationYearEQ: nullableNumberTypeFilter(),
	homeRoomSectionIDIn: asNodeIDArray,
	attendanceStatusTodayIDIn: asNodeIDArray,
	hasAttendanceToday: nullableBooleanTypeFilter(),
	reEnrollmentStatusEQ: valuesTypeFilter(["Re-Enrolling", "Withdrawing", "No Response", null], null),
	reEnrollmentMealPlan: nullableBooleanTypeFilter(),
	reEnrollmentContractStatusEQ: valuesTypeFilter(
		["Incomplete", "Ready for Review", "Approved", "Signed & Uploaded", null],
		null,
	),
};
